var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "管理分组",
        visible: _vm.visibleProxy,
        width: "600px",
        "append-to-body": "",
        "custom-class": "gm-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        },
        closed: _vm.onClosed
      }
    },
    [
      _c("div", { staticClass: "gm-subtitle" }, [_vm._v("仅展示自定义的分组")]),
      _vm._v(" "),
      _c("div", { staticClass: "gm-table" }, [
        _c("div", { staticClass: "gm-thead" }, [
          _c("div", { staticClass: "gm-th" }, [_vm._v("自定义组名")]),
          _vm._v(" "),
          _c("div", { staticClass: "gm-th" }, [_vm._v("快捷短语数量")]),
          _vm._v(" "),
          _c("div", { staticClass: "gm-th" }, [_vm._v("操作")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gm-tbody" },
          [
            _vm._l(_vm.customGroups, function(group) {
              return _c("div", { key: group.id, staticClass: "gm-tr" }, [
                _c(
                  "div",
                  { staticClass: "gm-td gm-name" },
                  [
                    _vm.editingGroupId === group.id
                      ? _c("el-input", {
                          ref: "editInput",
                          refInFor: true,
                          attrs: { size: "small" },
                          on: {
                            blur: function($event) {
                              return _vm.onSaveGroup(group)
                            }
                          },
                          nativeOn: {
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onSaveGroup(group)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onCancelEdit.apply(null, arguments)
                              }
                            ]
                          },
                          model: {
                            value: _vm.editingGroupName,
                            callback: function($$v) {
                              _vm.editingGroupName = $$v
                            },
                            expression: "editingGroupName"
                          }
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "gm-name-text",
                            class: {
                              "gm-name-hover": _vm.hoveredGroupId === group.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.onEditGroup(group)
                              },
                              mouseenter: function($event) {
                                _vm.hoveredGroupId = group.id
                              },
                              mouseleave: function($event) {
                                _vm.hoveredGroupId = null
                              }
                            }
                          },
                          [_vm._v(_vm._s(group.name))]
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "gm-td gm-count" }, [
                  _vm._v(_vm._s(group.replyList.length || 0))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gm-td gm-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "gm-delete-btn",
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.onDeleteGroup(group)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              ])
            }),
            _vm._v(" "),
            !_vm.customGroups || _vm.customGroups.length === 0
              ? _c("div", { staticClass: "gm-empty" }, [
                  _vm._v("暂无自定义分组")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddingNew
              ? _c("div", { staticClass: "gm-tr gm-add-row" }, [
                  _c(
                    "div",
                    { staticClass: "gm-td gm-name" },
                    [
                      _c("el-input", {
                        ref: "newGroupInput",
                        attrs: { size: "small", placeholder: "请输入分组名称" },
                        on: { blur: _vm.onSaveNewGroup },
                        nativeOn: {
                          keydown: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSaveNewGroup.apply(null, arguments)
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape"
                                ])
                              ) {
                                return null
                              }
                              return _vm.onCancelAdd.apply(null, arguments)
                            }
                          ]
                        },
                        model: {
                          value: _vm.newGroupName,
                          callback: function($$v) {
                            _vm.newGroupName = $$v
                          },
                          expression: "newGroupName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "gm-td gm-count" }, [_vm._v("0")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "gm-td gm-actions" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "gm-cancel-btn",
                          attrs: { type: "text" },
                          on: { click: _vm.onCancelAdd }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gm-add-group" },
        [
          _c(
            "el-button",
            { staticClass: "gm-add-btn", on: { click: _vm.onStartAddGroup } },
            [_vm._v("+ 新建分组")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.visibleProxy = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42207a70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42207a70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/GroupManageDialog.vue
// module id = 1751
// module chunks = 0